'use strict';

import Customer from 'common/models/Customer'

let cache = {};

class CustomerStore {
	constructor() {

	}

	getCustomer(customerId) {
		if(!cache[customerId]) {
			let customer = new Customer();
			customer.id = customerId;
			cache[customerId] = customer;
		}
		return cache[customerId];
	}

	saveCustomer(customer) {
		cache[customer.id] = customer;
		return customer;
	}

}

export default CustomerStore;


// WEBPACK FOOTER //
// ./client/app/common/stores/customerStore.js